import { apiClient } from './api'

export interface TOTPSetupResponse {
  secret: string
  otpauthUrl: string
  otpauth_url?: string
  issuer: string
  account_name?: string
  accountName?: string
}

export interface TOTPStatusResponse {
  enabled: boolean
  verified_at?: string
}

function getPartialToken(): string {
  return localStorage.getItem('partialToken') || ''
}

export const totpService = {
  setup: () =>
    apiClient.post<TOTPSetupResponse>('/auth/totp/setup', null, {
      headers: { 'X-Partial-Token': getPartialToken() },
    }),

  verifySetup: (code: string) =>
    apiClient.post('/auth/totp/verify-setup', { code }, {
      headers: { 'X-Partial-Token': getPartialToken() },
    }),

  verifyLogin: (partialToken: string, code: string) =>
    apiClient.post('/auth/totp/verify-login', {
      partial_token: partialToken,
      code,
    }),

  getStatus: () =>
    apiClient.get<TOTPStatusResponse>('/auth/totp/status', {
      headers: { 'X-Partial-Token': getPartialToken() },
    }),
}
